/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './http-interceptor';
import { ErrorRedirectInterceptor } from './http-error-redirect-interceptor';
import { NoInternetInterceptor } from './no-internet-toast-interceptor';
import { InternalServerErrorInterceptor } from './internal-server-error-interceptor';
/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorRedirectInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: NoInternetInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: InternalServerErrorInterceptor,
    multi: true,
  },
];
